import {
  Globe2,
  FileText,
  Handshake,
  Shield,
  Scale,
  Building2,
  Target,
  Users2,
  Lock,
  CheckCircle,
  ArrowRight,
  Landmark
} from "lucide-react";


export default function G2GTreatiesMoUsAdvisory() {
  const sections = [
    {
      id: "g2g-strategy",
      title: "G2G Strategy & Diplomatic Advisory",
      icon: Globe2,
      description: "Strategic framework for government-to-government engagements",
      points: [
        "Strategic advisory for Government-to-Government engagements",
        "Identification and prioritization of bilateral and multilateral cooperation areas",
        "Alignment of treaties and MoUs with national, state, and sectoral priorities",
        "Stakeholder mapping and engagement strategy",
        "Advisory on geopolitical, economic, and sector-specific considerations"
      ],
      image: "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=800&h=600"
    },
    {
      id: "treaty-structuring",
      title: "Treaty & MoU Structuring Advisory",
      icon: FileText,
      subsections: [
        {
          title: "Centre–State & Inter-State Agreements",
          points: [
            "Advisory on MoUs and agreements between State Governments and the Central Government",
            "Structuring of inter-state cooperation agreements",
            "Advisory on fiscal, administrative, and implementation frameworks",
            "Alignment with constitutional, statutory, and policy frameworks"
          ]
        },
        {
          title: "International Treaties & Bilateral / Multilateral MoUs",
          points: [
            "Advisory on bilateral treaties and MoUs between India and foreign governments",
            "Multilateral cooperation frameworks and agreements",
            "Sector-specific treaties (infrastructure, defence, energy, finance, trade, technology)",
            "Alignment with international conventions and best practices"
          ]
        }
      ],
      image: "https://images.pexels.com/photos/8761732/pexels-photo-8761732.jpeg?auto=compress&cs=tinysrgb&w=800&h=600"
    },
    {
      id: "negotiation-support",
      title: "Negotiation Support & Facilitation",
      icon: Handshake,
      description: "Expert guidance through complex inter-governmental negotiations",
      points: [
        "Negotiation strategy development and mandate preparation",
        "Technical, financial, and legal input support during negotiations",
        "Scenario analysis, risk assessment, and fallback positioning",
        "Facilitation of negotiation rounds and inter-governmental consultations",
        "Coordination with line ministries, state departments, and foreign counterparts"
      ],
      image: "https://images.pexels.com/photos/5668858/pexels-photo-5668858.jpeg?auto=compress&cs=tinysrgb&w=800&h=600"
    },
    {
      id: "drafting-documentation",
      title: "Drafting, Review & Documentation Support",
      icon: FileText,
      description: "Professional documentation and legal framework development",
      points: [
        "Drafting of treaties, MoUs, and inter-governmental agreements",
        "Review and harmonization of draft texts across stakeholders",
        "Preparation of annexures, implementation frameworks, and action plans",
        "Advisory on dispute resolution, exit clauses, and enforcement mechanisms"
      ],
      image: "https://images.pexels.com/photos/4226140/pexels-photo-4226140.jpeg?auto=compress&cs=tinysrgb&w=800&h=600"
    },
    {
      id: "regulatory-alignment",
      title: "Regulatory, Legal & Policy Alignment Advisory",
      icon: Scale,
      description: "Ensuring compliance with domestic and international legal frameworks",
      points: [
        "Advisory on alignment with Indian laws, constitutional provisions, and rules",
        "Compatibility assessment with international law and obligations",
        "Coordination with Ministry of External Affairs (MEA), Ministry of Law & Justice, and line ministries",
        "Advisory on approvals, ratification, and legislative processes"
      ],
      image: "https://images.pexels.com/photos/5668838/pexels-photo-5668838.jpeg?auto=compress&cs=tinysrgb&w=800&h=600"
    },
    {
      id: "sector-specific",
      title: "Sector-Specific G2G Advisory",
      icon: Building2,
      description: "Specialized advisory across all ministries and sectors",
      points: [
        "Infrastructure, urban development, and smart cities",
        "Defence cooperation and strategic infrastructure",
        "Banking, finance, and financial cooperation",
        "Energy, renewables, and climate cooperation",
        "Railways, transport, logistics, and connectivity",
        "Agriculture, food security, and irrigation",
        "Technology transfer, digital infrastructure, and innovation",
        "Healthcare, education, and skill development"
      ],
      image: "https://images.pexels.com/photos/3184338/pexels-photo-3184338.jpeg?auto=compress&cs=tinysrgb&w=800&h=600"
    },
    {
      id: "implementation-monitoring",
      title: "Post-Signing Implementation & Monitoring Advisory",
      icon: Target,
      description: "Translating agreements into actionable programs",
      points: [
        "Translation of treaties and MoUs into actionable programs",
        "Institutional and governance framework setup",
        "Monitoring, reporting, and performance review mechanisms",
        "Inter-governmental coordination during implementation",
        "Review, amendment, and renewal advisory"
      ],
      image: "https://images.pexels.com/photos/6693655/pexels-photo-6693655.jpeg?auto=compress&cs=tinysrgb&w=800&h=600"
    },
    {
      id: "multilateral-engagement",
      title: "Multilateral & Development Partner Engagement",
      icon: Users2,
      description: "Advisory for multilateral institutions and development partnerships",
      points: [
        "Advisory on engagement with multilateral institutions (World Bank, ADB, AIIB, etc.)",
        "Development finance and technical assistance agreement advisory",
        "Coordination with donor agencies and international partners",
        "Program structuring and compliance advisory"
      ],
      image: "https://images.pexels.com/photos/3184405/pexels-photo-3184405.jpeg?auto=compress&cs=tinysrgb&w=800&h=600"
    },
    {
      id: "confidentiality-protocol",
      title: "Confidentiality, Sensitivity & Protocol Advisory",
      icon: Lock,
      description: "Managing sensitive diplomatic engagements with discretion",
      points: [
        "Advisory on diplomatic protocol and confidentiality requirements",
        "Sensitive negotiation handling and information management",
        "Risk mitigation and contingency planning",
        "Crisis and dispute management advisory"
      ],
      image: "https://images.pexels.com/photos/6863183/pexels-photo-6863183.jpeg?auto=compress&cs=tinysrgb&w=800&h=600"
    }
  ];


  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <section className="bg-gradient-to-r from-yellow-600 to-yellow-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center max-w-4xl mx-auto">
            <div className="flex justify-center mb-6">
              <div className="p-4 bg-white/10 backdrop-blur-sm rounded-full">
                <Globe2 className="w-16 h-16" />
              </div>
            </div>
            <h1
              className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Government-to-Government (G2G) Treaties, MoUs & Inter-Governmental Advisory
            </h1>
            <p className="text-xl md:text-2xl text-yellow-50 mb-4">
              Central Government, State Governments & International Governments
            </p>
            <p className="text-yellow-100 text-lg">
              Comprehensive advisory for bilateral and multilateral agreements, treaty negotiations, 
              and inter-governmental cooperation frameworks
            </p>
          </div>
        </div>
      </section>


      {/* Universal Coverage Statement */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-yellow-500">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-yellow-100 rounded-lg flex-shrink-0">
                <Landmark className="w-8 h-8 text-yellow-600" />
              </div>
              <div>
                <h2 className="text-2xl font-bold mb-3 text-black">
                  Universal Coverage Statement
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  Advisory services extend to Central Government Ministries, State Governments, 
                  Autonomous Bodies, PSUs, and International Government Entities, supporting 
                  domestic and international G2G cooperation frameworks across all sectors and 
                  levels of government engagement.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Services Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2
              className="text-3xl md:text-4xl font-bold mb-4 text-black"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Our G2G Advisory Services
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto mb-4"></div>
            <p className="text-gray-600 max-w-3xl mx-auto">
              End-to-end support for government treaties, MoUs, and international cooperation agreements
            </p>
          </div>


          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {sections.map((section, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-yellow-500 group"
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden bg-gray-200">
                  <img
                    src={section.image}
                    alt={section.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    onError={(e) => {
                      e.target.src = "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=800&h=600";
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <div className="p-3 bg-yellow-500 rounded-lg">
                      <section.icon className="w-6 h-6 text-white" />
                    </div>
                  </div>
                </div>


                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2 text-black group-hover:text-yellow-600 transition-colors">
                    {section.title}
                  </h3>
                  {section.description && (
                    <p className="text-yellow-600 font-semibold text-sm mb-4">
                      {section.description}
                    </p>
                  )}
                  
                  {section.subsections ? (
                    <div className="space-y-4">
                      {section.subsections.map((subsection, idx) => (
                        <div key={idx}>
                          <h4 className="font-bold text-sm text-gray-900 mb-2">
                            {subsection.title}
                          </h4>
                          <ul className="space-y-1">
                            {subsection.points.map((point, pidx) => (
                              <li key={pidx} className="flex items-start gap-2">
                                <div className="w-1 h-1 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                                <span className="text-gray-600 text-xs leading-relaxed">
                                  {point}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <ul className="space-y-2">
                      {section.points.map((point, idx) => (
                        <li key={idx} className="flex items-start gap-2">
                          <div className="w-1.5 h-1.5 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                          <span className="text-gray-600 text-sm leading-relaxed">
                            {point}
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>


                {/* CTA */}
                <div className="px-6 pb-6">
                  <a
                    href="/contact"
                    className="block w-full text-center px-4 py-2 bg-gray-50 text-yellow-600 font-semibold rounded-lg hover:bg-yellow-600 hover:text-white transition-all duration-300"
                  >
                    Learn More
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* Key Differentiators */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-black">
              Why Choose Our G2G Advisory Services?
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto"></div>
          </div>


          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Globe2 className="w-8 h-8 text-yellow-600" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">100+ Treaties</h3>
              <p className="text-gray-600">Successfully advised and facilitated</p>
            </div>


            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users2 className="w-8 h-8 text-yellow-600" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">50+ Countries</h3>
              <p className="text-gray-600">International collaboration experience</p>
            </div>


            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-8 h-8 text-yellow-600" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">28 States</h3>
              <p className="text-gray-600">Centre-State advisory expertise</p>
            </div>


            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Lock className="w-8 h-8 text-yellow-600" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">100% Confidential</h3>
              <p className="text-gray-600">Diplomatic-grade discretion assured</p>
            </div>
          </div>
        </div>
      </section>


      {/* Disclaimer */}
      <section className="py-12 bg-black">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <div className="flex items-start gap-4">
            <div className="mt-1">
              <Shield className="w-7 h-7 text-yellow-500 flex-shrink-0" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-2">
                Important Disclaimer
              </h3>
              <p className="text-sm text-gray-300 leading-relaxed mb-2">
                All treaty and MoU advisory services are provided in coordination with authorized 
                government departments, legal advisors, and diplomatic channels. Final authority 
                and approvals rest solely with the respective governments and competent authorities.
              </p>
              <p className="text-sm text-gray-400">
                Advisory inputs support preparation, negotiation, documentation, and implementation 
                planning, while sovereign decisions, treaty ratification, and international 
                commitments remain the exclusive domain of constitutional authorities and designated 
                government representatives.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white">
        <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Partner for Strategic G2G Engagements
          </h2>
          <p className="text-lg text-yellow-50 mb-8">
            Whether you need support for bilateral treaties, multilateral agreements, or inter-state 
            cooperation frameworks, our specialized team provides comprehensive advisory services.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-yellow-600 font-bold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg"
            >
              Request Confidential Consultation
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
            <a
              href="mailto:info@hawkinsandbrooks.com"
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white font-bold rounded-lg hover:bg-white hover:text-yellow-600 transition-all duration-300"
            >
              Email G2G Advisory Desk
            </a>
          </div>


          {/* Trust Indicators */}
          <div className="mt-12 pt-12 border-t border-yellow-500/30">
            <p className="text-yellow-100 text-sm mb-6">
              Trusted by Central Ministries, State Governments, and International Partners
            </p>
            <div className="flex flex-wrap justify-center gap-8 text-sm">
              <span className="text-yellow-50">Ministry of External Affairs</span>
              <span className="text-yellow-50">NITI Aayog</span>
              <span className="text-yellow-50">State Governments</span>
              <span className="text-yellow-50">International Organizations</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
